<template>
  <div class="editable-page-model-h5-19" :style="{backgroundColor:editablePageConfig.editable_page_config_content.back_color,paddingTop:editablePageConfig.editable_page_config_content.margin_top,paddingBottom:editablePageConfig.editable_page_config_content.margin_bottom}">
    <div class="product-list">
      <div class="product-list-header" v-if="editablePageConfig.editable_page_config_content.text[0].list[0]">
        <div class="header-title">
          {{ editablePageConfig.editable_page_config_content.text[0].list[0].content }}
        </div>
      </div>
      <div class="product-list-body">
        <div
             v-for="(item, index) in editablePageConfig.goods_list[0]"
             v-bind:key="index"
             class="product-info"
             @click="productClick(item.goods_id)"
        >
          <img
            class="product-icon"
            v-bind:src="item.goods_image_url"
          />
          <span class="product-title">{{ item.goods_name }}</span>
          <div class="product-bottom">
            <span class="product-price">{{currency}} {{ item.goods_promotion_price }}</span>
            <span class="product-buy">{{ item.goods_salenum }} كمية المبيعات</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapState} from "vuex";

export default {
  name: 'Model19',
  data () {
    return {
    }
  },
  props: ['editablePageConfig'],
  computed: {
    ...mapState({
      currency: state => state.currency.currency
    })
  },
  methods: {
    productClick(goods_id) {
      this.$router.push({ name: 'HomeGoodsdetail', query: { goods_id: goods_id } })
    }
  }
}
</script>

<style lang="scss" scoped>
  .editable-page-model-h5-19 .product-list {
    background: #ffffff;
  }
  .editable-page-model-h5-19 .product-list .product-list-header {
    height: 2.65rem;
    line-height: 2.65rem;
    padding: 0 0.25rem;
    border-bottom: 1px solid #f5f5f5;
  }
  .editable-page-model-h5-19 .product-list .product-list-header .header-title {
    text-align: center;
    background: #1c1719;
    display: -webkit-box;
    height: 2.65rem;
    padding: 0 0.25rem;
    border-bottom: 1px solid #f5f5f5;
    -webkit-box-align: center;
    -webkit-box-pack: center;
    font-size: 0.8rem;
    color: #fff;
    font-weight: 700;
  }
  .editable-page-model-h5-19 .product-list .product-list-body {
    position: relative;
    display: flex;
    flex-wrap: wrap;
  }
  .editable-page-model-h5-19 .border {
    border-right: 1px solid #f5f5f5;
  }
  .editable-page-model-h5-19 .product-info {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 0.5rem;
    justify-content: flex-end;
    border-bottom: 1px solid #f5f5f5;
    width: 50%;
    box-sizing: border-box;
  }
  .editable-page-model-h5-19 .product-info .product-icon {
    align-self: center;
    width: 100%;
    box-sizing: border-box;
  }
  .editable-page-model-h5-19 .product-info .product-title {
    color: #333;
    font-size: .7rem;
    margin-top: 1rem;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
  .editable-page-model-h5-19 .product-info .product-bottom {
    display: flex;
    justify-content: space-between;
    margin-top: .4rem;
    line-height: 1rem;
  }
  .editable-page-model-h5-19 .product-info .product-bottom .product-price {
    color: #e93b3d;
    font-size: .7rem;
  }
  .editable-page-model-h5-19 .product-info .product-bottom .product-buy {
    color: #999999;
    font-size: .65rem;
  }
</style>
